// lib
import { styled } from '@nykaa/ui-components';

// constants
import { BREAKPOINTS, FOCUS_VISIBILITY_CSS } from 'shared/styles/base';
import { PDP_CONTAINER_WIDTH } from 'shared/layouts/DetailsPage/components/ProductInfo/Desktop/constants';

// mixin

export const PincodeContainer = styled.div`
  width: 100%;
  max-width: ${PDP_CONTAINER_WIDTH}px;
`;

export const DeliveryText = styled.p`
  margin: ${({ theme }) => `${theme.spacing.spacing20} 0 ${theme.spacing.spacing60} 0`};
  ${({ theme }) => theme.typography.bodyMedium}
  color: ${({ theme }) => theme.colors.textPrimary};

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    margin: ${({ theme }) => `0 0 ${theme.spacing.spacing80} 0`};
  }
`;

export const PincodeInputContainer = styled.div`
  width: 100%;
`;

export const TrailingButton = styled.button`
  border: none;
  outline: none;
  color: ${({ theme }) => theme.colors.secondary};
  background: none;
  cursor: pointer;
  padding: ${({ theme }) => `0 ${theme.spacing.spacing60}`};
  ${({ theme }) => theme.typography.buttonMedium}
  ${FOCUS_VISIBILITY_CSS}

  &[disabled] {
    cursor: not-allowed;
    pointer-events: none;
    color: ${({ theme }) => theme.colors.textOutline};
  }
  @media screen and (min-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme }) => theme.typography.buttonSmall};
  }
`;
